import React from "react"
import Moment from "../../moment"

const DateRangeCell = ({ value }) => {
  if (value && value.length > 1) {
    return (
      <span>
        <Moment value={value[0]} /> - <Moment value={value[1]} />
      </span>
    )
  } else if (value && value[0] && value[0].length > 0) {
    return <Moment value={value[0]} />
  } else {
    return null
  }
}

export default DateRangeCell
